<template>
  <div class="full-width pa-3 rounded cursor-pointer" style="border: 1px solid #e6e4eb; background-color: white">
    <div class="d-flex mb-2 justify-end">
      <CardActions
        renameTitle="Đổi tên đầu điểm"
        deleteTitle="Xóa đầu điểm"
        @onRename="() => $refs['rename-popup'].openPopup(mark)"
        @onDelete="onDelete"
      />
    </div>
    <v-tooltip top max-width="320px">
      <template v-slot:activator="{ on, attrs }">
        <div class="ellipsis-one-line text-body-1 text-none black--text" v-on="on" v-bind="attrs">
          {{ title }}
        </div>
      </template>
      <span class="text-justify">{{ title }}</span>
    </v-tooltip>
    <div class="mt-2 text-body-2">
      <div class="grey--text">
        Hệ số: <span class="font-weight-medium">{{ mark.factor }}</span>
      </div>
    </div>
    <div class="mt-2 text-body-2">
      <div class="grey--text">
        Thang điểm: <span class="font-weight-medium">{{ mark | getMarkType }}</span>
      </div>
    </div>
    <div class="mt-2 d-flex justify-space-between">
      <div class="grey--text text-body-2">Cập nhật lần cuối {{ lastUpdateAt }}</div>
    </div>
    <PopupEdit
      ref="rename-popup"
      popupTitle="Sửa tên đầu điểm"
      formLabel="Tên đầu điểm"
      formPlaceholder="Nhập tên đầu điểm"
      messageSuccess="Cập nhật tên đầu điểm thành công"
      @onRefresh="$emit('onRefresh')"
    />
  </div>
</template>
<script>
import CardActions from './CardActions.vue'
import PopupEdit from './PopupEdit.vue'
import moment from 'moment'
import get from 'lodash-es/get'
import { mapActions } from 'vuex'
export default {
  components: {
    CardActions,
    PopupEdit,
  },
  props: {
    mark: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      lastUpdateBy: '',
      lastUpdateAt: '',
      isMarked: false,
    }
  },
  methods: {
    ...mapActions({
      removeMarks: 'gradeMark/delete',
    }),
    formatDate(value) {
      return typeof value === 'string' && value.length ? moment(value).format('DD/MM/YYYY') : '--/--/--'
    },
    handleMark(val) {
      this.title = get(val, 'title', '')
      this.lastUpdateAt = this.formatDate(get(val, 'updatedAt', ''))
      // this.lastUpdateBy = get(val, 'markBy.name', 'Admin')
      this.isMarked = get(val, 'isMarked', false)
    },
    onDelete() {
      this.$dialog.confirm({
        title: 'Xoá đầu điểm',
        text: `Đầu điểm <span class="red--text">${this.title}</span> sẽ <span class="red--text">bị xoá hoàn toàn khỏi danh sách</span> và không thể khôi phục. <br/><br/>Hãy suy nghĩ kỹ trước khi tiếp tục.<br/>Bạn có chắc chắn muốn xóa đầu điểm này?`,
        doneButtonOutlined: true,
        cancelButtonOutlined: false,
        confirmColor: 'error',
        cancelColor: 'primary',
        okText: 'Xóa đầu điểm',
        done: async () => {
          try {
            await this.removeMarks(this.mark.id)
            this.$emit('onRefresh')
            this.$alert.success('Xóa đầu điểm thành công')
          } catch (error) {
            this.$alert.error('Xóa đầu điểm thất bại')
          }
        },
      })
    },
  },
  watch: {
    mark: {
      handler(val) {
        if (val) this.handleMark(val)
      },
      immediate: true,
      deep: true,
    },
  },
  filters: {
    getMarkType(mark) {
      const types = [
        { title: 'Thang điểm 10', value: 'per10' },
        { title: 'Thang điểm 100', value: 'per100' },
        { title: 'Thang điểm "Đạt / Không Đạt"', value: 'perBoolean' },
        { title: 'Khác', value: 'custom' },
      ]
      let title = types.find((x) => x.value === mark.type).title
      if (title === 'Khác') title += ' ' + mark.limit
      return title
    },
  },
}
</script>
